import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';

import { ComponentProps } from 'lib/component-props';
import withStyles from 'lib/enhancers/withStyles';

import styles from './ContainerThreeColumns.module.scss';

const cx = classNames.bind(styles);

type ContainerThreeColumnsProps = ComponentProps;

const ContainerThreeColumns = (props: ContainerThreeColumnsProps): React.JSX.Element => {
  const { className, rendering } = props;

  return (
    <div className={cx('container-three-columns', className)}>
      <div className={cx('container-three-columns__col')}>
        <Placeholder key={0} name="hp-container-three-col-left" rendering={rendering} disableSuspense={true} />
      </div>
      <div className={cx('container-three-columns__col')}>
        <Placeholder key={0} name="hp-container-three-col-middle" rendering={rendering} disableSuspense={true} />
      </div>
      <div className={cx('container-three-columns__col')}>
        <Placeholder key={0} name="hp-container-three-col-right" rendering={rendering} disableSuspense={true} />
      </div>
    </div>
  );
};

export default withStyles()<ContainerThreeColumnsProps>(ContainerThreeColumns);
